import { memoizeOne } from "@utils/memoizeOne";
import React from "react";
import { withTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";

import Page, { IPageParams, IProps as IPageProps } from "../../Page";
import { commonReportTranslations, getReportDefinition } from "../Report.utils";
import { ReportSplitPage } from "../ReportSplitPage";
import { IReportViewBaseProps } from "../ReportView";
import { getDefinition } from "./SocialSecurityContributionsOverview.def";

class SocialSecurityContributionsOverview extends Page<IPageProps> {

    static defaultProps = {
        getDef: getReportDefinition.bind(null, getDefinition)
    };

    getReportViewProps = memoizeOne((): Partial<IReportViewBaseProps> => {
        return {
            expandable: true
        };
    });

    render = () => {
        if (!this.isReady()) {
            return null;
        }

        return (
            <ReportSplitPage
                {...this.getMandatoryProps()}
                reportViewProps={this.getReportViewProps()}
            />
        );
    };

}

export default withRouter<RouteComponentProps<IPageParams>, any>(withTranslation([
    ...commonReportTranslations,
])(SocialSecurityContributionsOverview));